var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import * as R from "ramda";
import { getSdmxFormat } from "./getSdmxFormat.mjs";
import { getRangeHeader } from "./getRangeHeader.mjs";
const getRequestHeaders = (_a) => {
  var _b = _a, {
    datasource,
    type,
    locale,
    range
  } = _b, rest = __objRest(_b, [
    "datasource",
    "type",
    "locale",
    "range"
  ]);
  return R.pipe(
    R.assoc("Accept", getSdmxFormat(__spreadValues({ datasource, type }, rest))),
    (headers) => {
      const h = getRangeHeader({ type, datasource, range });
      return R.isEmpty(h) ? headers : R.assoc("x-range", R.prop("x-range", h), headers);
    }
  )({ "Accept-Language": locale });
};
export {
  getRequestHeaders
};
